module.exports = __webpack_public_path__ + "static/media/39-4.8bc1e100.mp3";